exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-feed-entry {\r\n  margin: 10px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/home/feed-card/feed-card.component.css
// module id = 130
// module chunks = 4